<body class=" text-uppercase" >
  <nav class="navbar navbar-expand-lg navbar-light">
  <div class="container">
    <a class="navbar-brand" routerLink="home">WiryaStore</a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarTogglerDemo03"
      aria-controls="navbarTogglerDemo03"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarTogglerDemo03">
      <ul class="navbar-nav ml-auto">
        <li class="nav-item">
          <a *ngIf="!this.userService.isLogin" class="nav-link " data-toggle="modal" data-target="#modalLoginForm" active>Sign in</a>
          <a *ngIf="this.userService.isLogin"(click)="logout()" class="nav-link ">Logout</a>
        </li>
        <li class="nav-item signStyle">
          <a *ngIf="!this.userService.isLogin" class="nav-link " routerLink="signup">Sign up</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLink="cart" *ngIf="this.userService.isLogin">
            <i class="fa fa-cart-arrow-down fa-lg" aria-hidden="true" >({{totalCart}})</i>
          </a>
        </li>
        <li class="nav-item">
          <a *ngIf="this.userService.isLogin" class="nav-link" [routerLink]="['/profile/detail']">
            <i class="fa fa-user-circle-o fa-lg" aria-hidden="true"></i>
          ></a>
        </li>
      </ul>
    </div>
  </div>
</nav>
  <div class="menuPage">
    <button class="btn buttonStyle " routerLink="home" active>Home</button>
    <li class="navbar text-center">
      <a class="btn buttonStyle dropdown-toggle" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Category
      </a>
      <div  class="dropdown-menu btn" aria-labelledby="navbarDropdown"(click)="reload()">
      <a  *ngFor="let category of category$ | async"  class="dropdown-item" [routerLink]="['category/' + category._id]">{{category.namecategory}}</a>
      </div>
    </li>
  </div>
</body>

